import axios from "axios";
import { prop } from "ramda";
import { mediaApiServiceUrl } from "@microServices";
export var getCloudfrontBaseUrl = function getCloudfrontBaseUrl() {
  return axios.get("".concat(mediaApiServiceUrl, "/cloudbase"), {
    headers: {
      "Content-Type": "application/json"
    }
  }).then(prop("data")).catch(function (error) {
    throw new Error(error);
  });
};